import React, { useState, useEffect } from 'react';
import DataTable from '../../components/DataTable';
import { useNavigate } from 'react-router-dom';
import api, { leadsAPI, clientsAPI, dealsAPI } from '../../lib/api';

const Leads = () => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchLeads = async () => {
    setLoading(true);
    try {
      const response = await leadsAPI.getAll();
      setLeads(response.data);
    } catch (error) {
      console.error('Error fetching leads:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeads();
  }, []);

  const columns = [
    { key: 'name', label: 'Name' },
    { key: 'email', label: 'Email' },
    { key: 'company', label: 'Company' },
  { key: 'contact_person', label: 'Contact Person' },
    { key: 'source', label: 'Source' },
    { key: 'value', label: 'Value', type: 'currency' },
    { key: 'status', label: 'Status', type: 'status' },
  ];

  const formFields = [
    { name: 'name', label: 'Name', required: true, placeholder: 'Lead name' },
    { name: 'email', label: 'Email', type: 'email', placeholder: 'lead@example.com' },
    { name: 'phone', label: 'Phone', placeholder: '+1-555-0000' },
    { name: 'company', label: 'Company', placeholder: 'Company name' },
  { name: 'contact_person', label: 'Contact Person', placeholder: 'Person to contact at this company' },
    { name: 'source', label: 'Source', placeholder: 'e.g., Website, Referral' },
    { name: 'value', label: 'Estimated Value', type: 'number', defaultValue: 0 },
    {
      name: 'status',
      label: 'Status',
      type: 'select',
      defaultValue: 'new',
      options: [
        { value: 'new', label: 'New' },
        { value: 'contacted', label: 'Contacted' },
        { value: 'qualified', label: 'Qualified' },
        { value: 'lost', label: 'Lost' },
      ],
    },
  { name: 'notes', label: 'Notes', type: 'textarea', placeholder: 'Anything worth remembering about this lead' },
  ];

  const handleAdd = async (data) => {
    await leadsAPI.create(data);
    fetchLeads();
  };

  const handleEdit = async (id, data) => {
    const existing = leads.find((lead) => lead.id === id);
    await leadsAPI.update(id, { ...data, converted_client_id: existing ? existing.converted_client_id : undefined, converted_deal_id: existing ? existing.converted_deal_id : undefined });
    fetchLeads();
  };

  const handleDelete = async (id) => {
    await leadsAPI.delete(id);
    fetchLeads();
  };
  const navigate = useNavigate();
  const handleConvertToClient = async (lead) => {
    if (lead.converted_client_id) return;
    const created = await clientsAPI.create({
      name: lead.name,
      company: lead.company,
      email: lead.email,
      phone: lead.phone,
    contact_person: lead.contact_person || (lead.company ? lead.name : undefined),
    source: lead.source,
    notes: lead.notes,
      status: "active",
    });
    const clientId = created.data ? created.data.id : created.id;
    await api.patch(`/leads/${lead.id}`, { status: "qualified", converted_client_id: clientId });
    fetchLeads();
  };
  const handleConvertToDeal = async (lead) => {
    if (lead.converted_deal_id) return;
    let clientId = lead.converted_client_id;
    if (!clientId) {
      const createdClient = await clientsAPI.create({ name: lead.name, company: lead.company, email: lead.email, phone: lead.phone, contact_person: lead.contact_person || (lead.company ? lead.name : undefined), source: lead.source, notes: lead.notes, status: 'active' });
      clientId = createdClient.data ? createdClient.data.id : createdClient.id;
      await api.patch('/leads/' + lead.id, { converted_client_id: clientId });
    }
    const createdDeal = await dealsAPI.create({
      name: lead.company || lead.name,
      stage: "qualification",
      client_id: clientId,
      stage: "qualification",
      value: Number(lead.value || lead.estimated_value || 0),
    });
    const dealId = createdDeal.data ? createdDeal.data.id : createdDeal.id;
    await api.patch(`/leads/${lead.id}`, { converted_deal_id: dealId });
    fetchLeads();
  };
  const leadCustomActions = [
    { label: "Convert to Client", onClick: handleConvertToClient, hidden: (lead) => !!lead.converted_client_id },
    { label: "View Client", onClick: (lead) => navigate(`/crm/clients/${lead.converted_client_id}`), hidden: (lead) => !lead.converted_client_id },
    { label: "Convert to Deal", onClick: handleConvertToDeal, hidden: (lead) => !!lead.converted_deal_id },
    { label: "View Deal", onClick: () => navigate("/crm/deals"), hidden: (lead) => !lead.converted_deal_id },
  ];

  return (
    <DataTable
      title="Leads"
      description="Potential customers not yet qualified or converted. Convert a lead to create its client, carrying its contact person, source and notes across."
      data={leads}
      columns={columns}
      formFields={formFields}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
        customActions={leadCustomActions}
      loading={loading}
    />
  );
};

export default Leads;
